export default "__VITE_PUBLIC_ASSET__9436e65b__"